import { useCallback } from 'react'
import { ArrowUpRightIcon } from 'lucide-react'
import { observer } from 'mobx-react-lite'
import { useTranslation } from 'react-i18next'

import { getWebAuthProviderConfig } from '@campai/lib-web/utils/auth'
import { Button, Card, CardDescription, CardFooter, CardHeader, CardTitle } from '@campai/lib-web/components/new/ui'

export const Security = observer(() => {
    const { t } = useTranslation()

    const handleOpenSecuritySettings = useCallback(() => {
        const { securitySettingsUrl } = getWebAuthProviderConfig()
        const newWindow = window.open(securitySettingsUrl, '_blank')

        if (newWindow) {
            newWindow.focus()
        }
    }, [])

    return (
        <Card>
            <CardHeader>
                <CardTitle>{t('profile.security.title')}</CardTitle>
                <CardDescription>{t('profile.security.description')}</CardDescription>
            </CardHeader>
            <CardFooter className="justify-end">
                <Button variant="outline" onClick={handleOpenSecuritySettings}>
                    <ArrowUpRightIcon data-icon="inline-start" />
                    {t('profile.security.securitySettings')}
                </Button>
            </CardFooter>
        </Card>
    )
})
